module.exports = __webpack_public_path__ + "static/media/ic_inbound_co_browse_disable.5a8169ba.svg";